import { render, staticRenderFns } from "./brandInfo.vue?vue&type=template&id=673ef929&scoped=true"
import script from "./brandInfo.vue?vue&type=script&lang=js"
export * from "./brandInfo.vue?vue&type=script&lang=js"
import style0 from "./brandInfo.vue?vue&type=style&index=0&id=673ef929&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673ef929",
  null
  
)

export default component.exports